import React from 'react';
import Link from "gatsby-link";
import Menu from '../Menu';
import BurgerButton from './BurgerButton';
import Socials from './Socials';

import logo from './logo.png';
import styles from './styles.scss';

class MainHeader extends React.PureComponent<> {
  state = {
    opened: false
  }

  toggleOpened = () => {
    this.setState((state) => ({
      opened: !state.opened,
    }))
  }

  handleClick = () => {
    this.setState({
      opened: false,
    })
  }

  render () {
    return (
      <header className="header">
        <div className="header__container">
          <div className="header__left">
            <Link to="/">
              <img
                src={logo}
                className="header__logo"
                alt="Custom Art - ogarniamy koncertowo"
              />
            </Link>
          </div>
          <div className="header__right">
            <div className="header__socials">
              <Socials />
            </div>
            <div className="header__burger">
              <BurgerButton onClick={this.toggleOpened} active={this.state.opened}/>
            </div>
          </div>
        </div>
        <Menu active={this.state.opened} onClick={this.handleClick}/>
      </header>
    );
  }
};

export default MainHeader;



// WEBPACK FOOTER //
// ./src/components/MainHeader/index.js